import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _excluded = ["eventType", "iconUrl"];

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { DeliveryIcon, FacebookIcon, GiftIcon, LevelUpIcon, LinkedinIcon, MegaphoneIcon } from '@infl-ts/ui-advocate-icons';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import AppleIcon from '@mui/icons-material/Apple';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import CheckIcon from '@mui/icons-material/Check';
import CommentIcon from '@mui/icons-material/Comment';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import PersonIcon from '@mui/icons-material/Person';
import ThumbsUpIcon from '@mui/icons-material/ThumbUp';
import TwitterIcon from '@mui/icons-material/Twitter';
import UndoIcon from '@mui/icons-material/Undo';
import { Box, styled } from '@mui/material';
import { flow } from 'fp-ts/function';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var absoluteImagePath = function absoluteImagePath(url) {
  return true ? url : url.replace(/^\/\/fe-proxy\.infldev\.com/, 'https://fe-proxy.infldev.com');
};

var IconWrapper = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 0;\n  right: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.spacing(1);
});
var defaultIconStyles = {
  fontSize: function fontSize(theme) {
    return theme.typography.caption.fontSize;
  },
  border: 2,
  borderColor: function borderColor(theme) {
    return theme.palette.common.white;
  },
  borderRadius: 50,
  boxSizing: 'content-box',
  fill: function fill(theme) {
    return theme.palette.common.white;
  },
  p: function p(theme) {
    return theme.spacing(0.25);
  }
};

var primaryStyles = _objectSpread(_objectSpread({}, defaultIconStyles), {}, {
  backgroundColor: function backgroundColor(theme) {
    return theme.palette.primary.main;
  }
});

var successStyles = _objectSpread(_objectSpread({}, defaultIconStyles), {}, {
  backgroundColor: function backgroundColor(theme) {
    return theme.palette.success.main;
  }
});

var eventTypesWithCustomImage = ['reward_available', 'redemption_requested', 'redemption_refused', 'reward_fulfilled', 'link_reward_fulfilled', 'new_reward_available', 'wishlist_reward_afford', 'corporate_confirmation', 'received_feedback', 'corporate_redo', 'logged_activity', 'earned_badge', 'completed_challenge'];

var hasItsOwnImage = function hasItsOwnImage(eventType) {
  return eventTypesWithCustomImage.includes(eventType);
};

var icon = function icon(eventType) {
  switch (eventType) {
    case 'twitter_connected':
      return /*#__PURE__*/_jsx(TwitterIcon, {
        sx: [defaultIconStyles, {
          backgroundColor: function backgroundColor(t) {
            return t.palette.other.twitter;
          }
        }]
      });

    case 'linkedin_connected':
      return /*#__PURE__*/_jsx(LinkedinIcon, {
        sx: [defaultIconStyles, {
          backgroundColor: function backgroundColor(t) {
            return t.palette.other.linkedIn;
          }
        }]
      });

    case 'apple_connected':
      return /*#__PURE__*/_jsx(AppleIcon, {
        sx: [defaultIconStyles, function (t) {
          return {
            fill: t.palette.common.black,
            backgroundColor: function backgroundColor(t) {
              return t.palette.common.white;
            },
            borderColor: function borderColor(t) {
              return t.palette.common.black;
            },
            filter: 'invert(1)'
          };
        }]
      });

    case 'facebook_connected':
      return /*#__PURE__*/_jsx(FacebookIcon, {
        sx: [defaultIconStyles, {
          backgroundColor: function backgroundColor(t) {
            return t.palette.other.facebook;
          }
        }]
      });

    case 'reward_available':
      return /*#__PURE__*/_jsx(CardGiftcardIcon, {
        sx: primaryStyles
      });

    case 'reward_fulfilled':
      return /*#__PURE__*/_jsx(DeliveryIcon, {
        sx: primaryStyles
      });

    case 'referral_milestone_reached':
      return /*#__PURE__*/_jsx(MegaphoneIcon, {
        sx: primaryStyles
      });

    case 'referred_prospect_accepted':
      return /*#__PURE__*/_jsx(MegaphoneIcon, {
        sx: primaryStyles
      });

    case 'referred_prospect_won':
      return /*#__PURE__*/_jsx(MegaphoneIcon, {
        sx: successStyles
      });

    case 'referred_prospect_submitted':
      return /*#__PURE__*/_jsx(MegaphoneIcon, {
        sx: primaryStyles
      });

    case 'corporate_confirmation':
      return /*#__PURE__*/_jsx(CheckIcon, {
        sx: successStyles
      });

    case 'received_feedback':
      return /*#__PURE__*/_jsx(CommentIcon, {
        sx: primaryStyles
      });

    case 'corporate_redo':
      return /*#__PURE__*/_jsx(UndoIcon, {
        sx: primaryStyles
      });

    case 'logged_activity':
      return /*#__PURE__*/_jsx(DoubleArrowIcon, {
        sx: primaryStyles
      });

    case 'advanced_level':
      return /*#__PURE__*/_jsx(LevelUpIcon, {
        sx: primaryStyles
      });

    case 'upgraded_to_advocate':
      return /*#__PURE__*/_jsx(UndoIcon, {
        sx: primaryStyles
      });

    case 'community_topic_liked':
      return /*#__PURE__*/_jsx(ThumbsUpIcon, {
        sx: primaryStyles
      });

    case 'community_topic_replied':
      return /*#__PURE__*/_jsx(CommentIcon, {
        sx: primaryStyles
      });

    case 'community_mention':
      return /*#__PURE__*/_jsx(AlternateEmailIcon, {
        sx: primaryStyles
      });

    default:
      return null;
  }
};

var StyledImage = styled('img')({
  height: '40px',
  width: '40px',
  borderRadius: 50
});

var BigIcon = function BigIcon(_ref2) {
  var eventType = _ref2.eventType,
      bigIconUrl = _ref2.bigIconUrl,
      avatarUrl = _ref2.avatarUrl;
  if (bigIconUrl && hasItsOwnImage(eventType)) return /*#__PURE__*/_jsx(StyledImage, {
    src: absoluteImagePath(bigIconUrl)
  });

  if (eventType === 'reward_available') {
    return /*#__PURE__*/_jsx(GiftIcon, {
      sx: {
        fontSize: 40,
        background: function background(t) {
          return t.palette.primary.background;
        },
        fill: function fill(t) {
          return t.palette.primary.main;
        },
        borderRadius: 50
      }
    });
  }

  if (avatarUrl) return /*#__PURE__*/_jsx(StyledImage, {
    src: absoluteImagePath(avatarUrl),
    height: "40px",
    width: "40px"
  });
  return /*#__PURE__*/_jsx(PersonIcon, {
    sx: function sx(t) {
      return {
        fontSize: 40,
        backgroundColor: function backgroundColor(t) {
          return t.palette.primary.main;
        },
        fill: t.palette.common.white,
        borderRadius: 50
      };
    },
    "data-element": "PersonIcon",
    "data-component": "BigIcon",
    "data-source-file": "item-image.tsx"
  });
};

var PureItemImage = function PureItemImage(_ref3) {
  var bigIconUrl = _ref3.bigIconUrl,
      smallIcon = _ref3.smallIcon,
      eventType = _ref3.eventType,
      avatarUrl = _ref3.avatarUrl;
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      position: 'relative'
    },
    "data-element": "Box",
    "data-component": "PureItemImage",
    "data-source-file": "item-image.tsx",
    children: [/*#__PURE__*/_jsx(Box, {
      sx: {
        margin: '4px 16px',
        minWidth: 40,
        minHeight: 40
      },
      "data-element": "Box",
      "data-component": "PureItemImage",
      "data-source-file": "item-image.tsx",
      children: /*#__PURE__*/_jsx(BigIcon, {
        eventType: eventType,
        bigIconUrl: bigIconUrl,
        avatarUrl: avatarUrl,
        "data-element": "BigIcon",
        "data-component": "PureItemImage",
        "data-source-file": "item-image.tsx"
      })
    }), smallIcon && /*#__PURE__*/_jsx(IconWrapper, {
      children: smallIcon
    })]
  });
};

var useProps = function useProps(_ref4) {
  var eventType = _ref4.eventType,
      iconUrl = _ref4.iconUrl,
      rest = _objectWithoutProperties(_ref4, _excluded);

  return _objectSpread({
    smallIcon: icon(eventType),
    bigIconUrl: iconUrl,
    eventType: eventType
  }, rest);
};

export default Object.assign(flow(useProps, PureItemImage), {
  displayName: 'ItemImage'
});